import { keyMirror } from 'redfish-core/lib/utils/utils'

export const actionTypes = keyMirror(['LOADED', 'LOADING', 'FULL_STATE'])
